import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

const config = {
    apiKey: "AIzaSyAbLnIZxkw01r-UaAkcVZE2MxGoed206Xg",
    authDomain: "chat-web-app-54ef0.firebaseapp.com",
    projectId: "chat-web-app-54ef0",
    storageBucket: "chat-web-app-54ef0.appspot.com",
    messagingSenderId: "145957406770",
    appId: "1:145957406770:web:fe2607bea3b1faae2a942b"
  };

  const app = firebase.initializeApp(config);

export const auth = app.auth();
export const database = app.database();
export const  storage = app.storage();
